import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Browser wallet extensions (e.g. MetaMask's inpage.js) inject code that throws
// "Failed to connect to MetaMask" on some pages. This site uses no web3, so those
// errors are noise. The webpack-dev-server error overlay catches them and hijacks the
// preview. We (1) preventDefault extension-originated error events, and (2) remove the
// dev overlay ONLY when its content is an extension/MetaMask error — real app-error
// overlays are left intact.
const EXT_RE = /chrome-extension:\/\/|moz-extension:\/\/|MetaMask/i;
const isExtensionNoise = (val) => {
  const msg = (val && (val.message || val.reason?.message)) || String(val?.reason || val || "");
  const stack = (val && (val.stack || val.reason?.stack)) || "";
  return EXT_RE.test(`${msg} ${stack}`);
};
window.addEventListener("error", (e) => {
  if (isExtensionNoise(e.error || e)) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  if (isExtensionNoise(e)) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);

const scrubExtensionOverlay = () => {
  const ov = document.getElementById("webpack-dev-server-client-overlay");
  if (!ov) return;
  try {
    const doc = ov.contentDocument || ov.contentWindow?.document;
    const text = doc ? doc.body.innerText : "";
    if (EXT_RE.test(text)) ov.remove();
  } catch (_) { /* cross-origin or timing — ignore */ }
};
if (typeof MutationObserver !== "undefined") {
  new MutationObserver(() => {
    scrubExtensionOverlay();
    setTimeout(scrubExtensionOverlay, 60); // iframe content populates async
  }).observe(document.documentElement, { childList: true, subtree: true });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
